<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-form-model layout="inline" :colon="false" :model="form" @keyup.enter.native="query">
        <a-row>
          <a-col :span="18">
            <a-form-model-item>
              <a-month-picker
                placeholder="月报期数"
                :value="form.reportPeriodValue"
                @change="onMonthChange"
                format="YYYY/MM"
                style="width: 150px"
              />
            </a-form-model-item>

            <a-form-model-item>
              <a-select placeholder="状态" v-model="form.status" style="width: 150px" allow-clear>
                <a-select-option v-for="item in statusList" :key="item.value" :value="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <div class="right" style="margin-top: 4px">
              <a-space>
                <a-button @click="showConfigModal">参数配置</a-button>
                <a-button @click="download" type="primary">导出文件</a-button>
              </a-space>
            </div>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table bordered :data-source="list" :loading="loading" @change="onChange" :scroll="{ x: 1400 }" :pagination="{
        total,
        current,
        pageSize,
        showTotal: (total) => `共 ${total} 条记录`,
      }">
        <a-table-column title="月报期数" data-index="reportPeriod" align="center" width="100px">
        </a-table-column>

        <a-table-column title="周期" data-index="cycleText" align="center" width="120px">
        </a-table-column>

        <a-table-column-group title="当月总产值(元)">
          <a-table-column title="总院" width="100px" align="right">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ moneyFilter(text.totalOutputValueHead) }}</span>
            </template>
          </a-table-column>
          <a-table-column title="分院" width="100px" align="right">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ moneyFilter(text.totalOutputValueBranch) }}</span>
            </template>
          </a-table-column>
        </a-table-column-group>

        <a-table-column-group title="当月分包总成本(元)">
          <a-table-column title="总院" width="100px" align="right">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ moneyFilter(text.totalSubcontractCostHead) }}</span>
            </template>
          </a-table-column>
          <a-table-column title="分院" width="100px" align="right">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ moneyFilter(text.totalSubcontractCostBranch) }}</span>
            </template>
          </a-table-column>
        </a-table-column-group>

        <a-table-column-group title="当月总净产值(元)">
          <a-table-column title="总院" width="100px" align="right">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ moneyFilter(text.totalNetOutputValueHead) }}</span>
            </template>
          </a-table-column>
          <a-table-column title="分院" width="100px" align="right">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ moneyFilter(text.totalNetOutputValueBranch) }}</span>
            </template>
          </a-table-column>
        </a-table-column-group>

        <a-table-column title="状态" align="center" width="90px">
          <template slot-scope="text">
            <DataDictFinder dictType="progressStatus" :dictValue="text.status" iconType="tag" />
          </template>
        </a-table-column>

        <a-table-column title="经管对接人" data-index="confirmUserName" align="center" width="100px">
        </a-table-column>

        <a-table-column title="确认时间" data-index="confirmAt" align="center" width="160px">
        </a-table-column>

        <a-table-column align="center" width="200px" title="操作" fixed="right">
          <template slot-scope="text">
            <a-button
              type="link"
              size="small"
              :disabled="!!text.confirmAt"
              @click="confirm(text)"
            >
              确认
            </a-button>
            <a-button
              type="link"
              size="small"
              @click="view(text)"
            >
              查看
            </a-button>
            <a-button
              type="link"
              size="small"
              :loading="refreshingId === text.id"
              @click="refresh(text)"
            >
              刷新
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </a-card>

    <!-- 参数配置弹框 -->
    <a-modal
      :visible="configVisible"
      title="产值进度月报-参数配置"
      @cancel="configVisible = false"
      @ok="handleConfigOk"
      :confirmLoading="configLoading"
      width="560px"
    >
      <a-spin :spinning="configLoading">
        <a-form-model
          ref="configForm"
          :model="configForm"
          :rules="configRules"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-form-model-item label="月报生成日期" prop="reportGenerateDay">
            <a-input-number
              v-model="configForm.reportGenerateDay"
              :min="1"
              :max="27"
              :precision="0"
              style="width: 100%"
              placeholder="请输入1-27之间的数字"
            />
            <div style="color: #999; font-size: 12px; line-height: 1.5; margin-top: 4px;">
              *生成的月报数据范围是上月{{ rangeStartDay }}号至本月{{ rangeEndDay }}号
            </div>
          </a-form-model-item>

          <a-form-model-item label="分院成本系数" prop="branchCostRatio">
            <a-input-number
              v-model="configForm.branchCostRatio"
              :min="0"
              :max="1"
              :precision="2"
              :step="0.01"
              style="width: 100%"
              placeholder="请输入0-1之间的数字"
            />
            <div style="color: #999; font-size: 12px; line-height: 1.5; margin-top: 4px;">
              *请输入0-1之间的数字，用于计算分院的分包成本
            </div>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import screen from "@/mixins/screen";
import watermark from "@/mixins/watermark";
import { fetchProgressReportList, fetchProgressReportConfig, saveProgressReportConfig, confirmProgressReport, generateMonthlyReport } from "@/api/finance/progress-report";
import { downloadByHtml } from "@/utils/xlsx";
import moment from 'moment';

export default {
  name: "progress-report",
  mixins: [screen, watermark],

  data() {
    return {
      form: {
        reportPeriodValue: null,
        reportPeriod: '',
      },
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      refreshingId: null,

      configVisible: false,
      configLoading: false,
      configForm: {
        id: null,
        reportGenerateDay: undefined,
        branchCostRatio: undefined,
      },
      configRules: {
        reportGenerateDay: [
          { required: true, message: "请输入1-27之间的数字", trigger: "blur" },
        ],
        branchCostRatio: [
          { required: true, message: "请输入0-1之间的数字", trigger: "blur" },
        ],
      },
    };
  },

  activated() {
    this.$store.dispatch("setting/getDataDict").finally(() => {
      this.getList();
    });
  },

  computed: {
    statusList() {
      return this.$store.getters["setting/findDataDict"]("progressStatus");
    },
    rangeStartDay() {
      return this.configForm.reportGenerateDay;
    },
    rangeEndDay() {
      return this.configForm.reportGenerateDay - 1;
    },
  },

  methods: {
    ...mapMutations("tabs", ["setTabList"]),

    getList() {
      const { current, pageSize } = this;
      this.loading = true;
      fetchProgressReportList({
        pageNum: current,
        pageSize,
        reportPeriod: this.form.reportPeriod,
        status: this.form.status,
      })
        .then((res) => {
          if (res && Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },

    reset() {
      this.form = {
        reportPeriodValue: null,
        reportPeriod: '',
      };
      this.current = 1;
      this.getList();
    },

    refresh(record) {
      const that = this;
      const match = (record.reportPeriod || "").match(/^(\d+)年(\d+)月$/);
      if (!match) {
        this.$message.error("无法解析月报期数");
        return;
      }
      const year = Number(match[1]);
      const month = Number(match[2]);
      this.$confirm({
        title: "刷新月报",
        content: `将根据当前合同数据重新生成「${record.reportPeriod}」月报，是否继续？`,
        onOk() {
          that.refreshingId = record.id;
          return generateMonthlyReport({ year, month })
            .then(() => {
              that.$message.success("刷新成功");
              that.getList();
            })
            .finally(() => {
              that.refreshingId = null;
            });
        },
      });
    },

    onMonthChange(date) {
      this.form.reportPeriodValue = date;
      if (date) {
        const year = date.year();
        const month = date.month() + 1;
        this.form.reportPeriod = `${year}年${month}月`;
      } else {
        this.form.reportPeriod = '';
      }
    },

    confirm(record) {
      const that = this;
      this.$confirm({
        title: "确认月报",
        content: `确认月报「${record.reportPeriod}」？确认后经管对接人与确认时间将被记录`,
        onOk() {
          return confirmProgressReport({ reportId: record.id }).then(() => {
            that.$message.success("确认成功");
            that.getList();
          });
        },
      });
    },

    view(record) {
      const path = `/finance/progress-report/detail?reportId=${record.id}&reportPeriod=${encodeURIComponent(record.reportPeriod)}`;
      const basePath = `/finance/progress-report/detail`;
      const tabList = [...this.$store.state.tabs.tabList];
      if (!tabList.some(t => t.path === basePath)) {
        tabList.push({ name: '产值进度月报详情', path: basePath, fullPath: path });
        this.setTabList(tabList);
      }
      this.$router.push(path).catch(() => {});
    },

    showConfigModal() {
      this.configVisible = true;
      this.configLoading = true;
      fetchProgressReportConfig()
        .then((res) => {
          if (res) {
            this.configForm = {
              id: res.id || null,
              reportGenerateDay: res.reportGenerateDay,
              branchCostRatio: res.branchCostRatio,
            };
          }
        })
        .finally(() => {
          this.configLoading = false;
        });
    },

    handleConfigOk() {
      this.$refs.configForm.validate((valid) => {
        if (valid) {
          this.configLoading = true;
          saveProgressReportConfig({
            id: this.configForm.id,
            reportGenerateDay: this.configForm.reportGenerateDay,
            branchCostRatio: this.configForm.branchCostRatio,
          })
            .then(() => {
              this.$message.success("保存成功");
              this.configVisible = false;
            })
            .finally(() => {
              this.configLoading = false;
            });
        }
      });
    },

    download() {
      downloadByHtml(document.getElementsByTagName("table")[0], "产值进度月报");
    },

    moneyFilter(money) {
      if (typeof money !== "number") {
        return "--";
      }
      return money.toLocaleString();
    },
  },
};
</script>